import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import TypingPlaceholder from './TypingPlaceholder';
import { useDebounce } from '../hooks/useDebounce';

interface WillSearchProps {
  className?: string;
  onSearch: (term: string) => void;
}

export interface WillSearchRef {
  setInputValue: (value: string) => void;
}

export const WillSearch = forwardRef<WillSearchRef, WillSearchProps>(({ className, onSearch }, ref) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const debouncedSearch = useDebounce((term: string) => {
    setIsTyping(false);
    onSearch(term);
  }, 300);

  // Expose methods via the ref
  useImperativeHandle(ref, () => ({
    setInputValue: (value: string) => {
      setSearchTerm(value);
      if (inputRef.current) {
        inputRef.current.value = value;
      }
    }
  }));

  return (
    <div className={className}>
      <div className="relative">
        <input
          ref={inputRef}
          type="text"
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={searchTerm}
          onChange={(e) => {
            setIsTyping(true);
            setSearchTerm(e.target.value);
            debouncedSearch(e.target.value);
          }}
          placeholder="Search wills..."
        />
        {isTyping && (
          <TypingPlaceholder 
            className="absolute right-3 top-1/2 transform -translate-y-1/2"
            phrases={["Searching...", "Looking for wills...", "Please wait..."]}
          />
        )}
      </div>
    </div>
  );
}); 